// App.js

import React, {useEffect} from 'react';
import MainRoutes from 'config/MainRoutes';
import {AuthProvider} from "contexts/AuthContext";
import {ToastContainer} from 'react-toastify';

import './App.css';

const App = () => {

    // 마우스 우클릭 방지
    useEffect(() => {
        const handleRightClick = (e) => {
            e.preventDefault(); // 우클릭 메뉴 방지
        };

        window.addEventListener('contextmenu', handleRightClick);

        // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
        return () => {
            window.removeEventListener('contextmenu', handleRightClick);
        };
    }, []);


    return (
        <AuthProvider>
            <MainRoutes/>
            <ToastContainer position="bottom-center"/>
        </AuthProvider>
    );
};

export default App;